export const VIDEO_NOTIFICATION_POLL_INTERVAL_MS = 60_000; // 1 minute
export const VIDEO_NOTIFICATION_HISTORY_CAP = 50; // 50 notifications
export const VIDEO_NOTIFICATION_TOAST_DURATION_MS = 5_000; // 5 seconds
